import { Component } from '@angular/core';
import { IconComponent } from '../../shared';
import { MODULES } from '../../content/home.content';

@Component({
  selector: 'app-modules',
  imports: [IconComponent],
  templateUrl: './modules.component.html'
})
export class ModulesComponent {
  readonly modules = MODULES;
  readonly performance = [
    { label: 'Cardio', height: 'h-[40%]', color: 'bg-primary/20' },
    { label: 'Neuro', height: 'h-[60%]', color: 'bg-primary/40' },
    { label: 'Onco', height: 'h-[85%]', color: 'bg-primary/60' },
    { label: 'Intensiva', height: 'h-[95%]', color: 'bg-primary' },
    { label: 'Pediatria', height: 'h-[70%]', color: 'bg-primary/50' }
  ];
  readonly courses = [
    { label: 'Protocolo de sepse', progress: 92 },
    { label: 'Higiene das mãos', progress: 100 },
    { label: 'Cirurgia segura', progress: 78 }
  ];
  readonly vaccines = [
    { label: 'Hepatite B', color: 'text-success' },
    { label: 'Influenza', color: 'text-success' },
    { label: 'Tétano', color: 'text-gold' }
  ];
}
